import { useLingui } from "@lingui/react/macro";
import { usePatient } from "@/api/Patients";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { Loading } from "@medoma/components/Loading/Loading";
import { deducedError } from "@/Utils/ErrorUtils";
import { Outlet, useParams } from "react-router";
import { z } from "zod";
import * as Sentry from "@sentry/react";

export const Information = () => {
  const { t } = useLingui();
  const { patientId } = z.object({ patientId: z.string() }).parse(useParams());
  const { data: patient, isPending, isError, error } = usePatient(patientId);

  if (isPending) {
    return <Loading message={t`Laddar patient`} />;
  }

  if (isError) {
    Sentry.captureException(error);
    return (
      <ErrorMessage
        message={`${t`Kunde inte hämta patientdetaljer.`} ${deducedError(error)}`}
      />
    );
  }

  return <Outlet context={patient} />;
};
